import { Link } from 'react-router-dom'
import logo from '@/assets/logo.svg'

const NotFound = () => {
  return (
    <div className="flex h-screen w-full flex-col items-center justify-center p-4">
      <div className="flex flex-col items-center gap-6 rounded-xl bg-white/5 p-8 shadow-lg backdrop-blur-sm">
        <img src={logo} alt="RecipeVision logo" className="h-16 w-16" />
        <div className="text-center">
          <h1 className="text-4xl font-bold text-white">404</h1>
          <p className="mt-2 text-xl text-white/80">Page not found</p>
          <p className="mt-1 text-white/60">The page you're looking for doesn't exist or has been moved.</p>
        </div>
        <Link
          to="/"
          className="rounded-md bg-neutral-700 px-4 py-2 text-sm/6 font-semibold text-white shadow-inner shadow-white/10 transition-colors hover:bg-neutral-600"
        >
          Go back home
        </Link>
      </div>
    </div>
  )
}

export default NotFound
